module.exports = __webpack_public_path__ + "img/initialEle.eff51bff.svg";